import * as actions from "./actions";

const initialState = {
  initial: false,
  users: [],
  stats: null,
  pagination: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
  },
  isFetchingUsers: false,
  isFetchingStats: false,
  isGranting: false,
  isRevoking: false,
  isBulkGranting: false,
  error: null,
  lastGrantResult: null,
  lastRevokeResult: null,
};

const proManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Pro Users
    case actions.FETCH_PRO_USERS.REQUEST:
      return {
        ...state,
        isFetchingUsers: true,
        error: null,
      };

    case actions.FETCH_PRO_USERS.SUCCESS:
      return {
        ...state,
        initial: true,
        isFetchingUsers: false,
        users: action.payload.data.users,
        pagination: {
          page: action.payload.data.page,
          pageSize: action.payload.data.page_size,
          total: action.payload.data.total,
          totalPages: action.payload.data.total_pages,
        },
        error: null,
      };

    case actions.FETCH_PRO_USERS.FAILURE:
      return {
        ...state,
        isFetchingUsers: false,
        error: action.payload,
      };

    // Fetch Pro Stats
    case actions.FETCH_PRO_STATS.REQUEST:
      return {
        ...state,
        isFetchingStats: true,
        error: null,
      };

    case actions.FETCH_PRO_STATS.SUCCESS:
      return {
        ...state,
        isFetchingStats: false,
        stats: action.payload.data,
        error: null,
      };

    case actions.FETCH_PRO_STATS.FAILURE:
      return {
        ...state,
        isFetchingStats: false,
        error: action.payload,
      };

    // Grant Complimentary Pro
    case actions.GRANT_COMPLIMENTARY_PRO.REQUEST:
      return {
        ...state,
        isGranting: true,
        error: null,
        lastGrantResult: null,
      };

    case actions.GRANT_COMPLIMENTARY_PRO.SUCCESS:
      return {
        ...state,
        isGranting: false,
        lastGrantResult: action.payload.data,
        error: null,
      };

    case actions.GRANT_COMPLIMENTARY_PRO.FAILURE:
      return {
        ...state,
        isGranting: false,
        error: action.payload.error,
      };

    // Revoke Complimentary Pro
    case actions.REVOKE_COMPLIMENTARY_PRO.REQUEST:
      return {
        ...state,
        isRevoking: true,
        error: null,
        lastRevokeResult: null,
      };

    case actions.REVOKE_COMPLIMENTARY_PRO.SUCCESS:
      return {
        ...state,
        isRevoking: false,
        lastRevokeResult: action.payload.data,
        error: null,
      };

    case actions.REVOKE_COMPLIMENTARY_PRO.FAILURE:
      return {
        ...state,
        isRevoking: false,
        error: action.payload.error,
      };

    // Bulk Grant Complimentary Pro
    case actions.BULK_GRANT_COMPLIMENTARY_PRO.REQUEST:
      return {
        ...state,
        isBulkGranting: true,
        error: null,
      };

    case actions.BULK_GRANT_COMPLIMENTARY_PRO.SUCCESS:
      return {
        ...state,
        isBulkGranting: false,
        error: null,
      };

    case actions.BULK_GRANT_COMPLIMENTARY_PRO.FAILURE:
      return {
        ...state,
        isBulkGranting: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default proManagementReducer;
